module.exports = __webpack_public_path__ + "r-v3/img/arrowLeft_white.bc9c3ac9.svg";